import { DetectOverflow } from "@data-display/wrapper/DetectOverflow";
import { TooltipOverflow } from "@data-display/wrapper/DetectOverflow/TooltipOverflow";
import { Box, Icon, Typography } from "@mui/material";
import { createRef, useState } from "react";
import { ChipButton } from "../styles";
import { DropdownPopover } from "./DropdownPopover";

/**
 * Dropdown Chip Component
 * @param {Object} props
 * @param {String} id Dropdown Chip id
 * @param {Boolean} open
 * @param {String} label Dropdown Chip label
 * @param {Element} LabelComponent
 * @param {Object} inputProps Dropdown Chip Component props
 * @param {Function} onClick Function to execute on input click
 * @param {Element} children Dropdown Popover children
 * @returns JSX.Element
 */
export const ChipDropdown = ({
  id,
  open,
  label,
  LabelComponent,
  togglerProps,
  onClick,
  children,
  PaperProps,
  labelProps,
  ...props
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const boxRef = createRef();

  const handleClick = () => {
    setAnchorEl(boxRef.current);
    onClick();
  };

  const handleClose = () => {
    setAnchorEl(null);
    onClick();
  };

  return (
    <>
      {/* Chip Part */}
      <Box>
        <ChipButton
          id={`${id}-input`}
          role="listbox"
          onClick={handleClick}
          ref={boxRef}
          data-testid={id}
          label={
            <>
              {LabelComponent && <LabelComponent />}
              {!LabelComponent && (
                <DetectOverflow component={Typography} variant="body2" {...labelProps}>
                  <TooltipOverflow text={label} />
                </DetectOverflow>
              )}
              <Icon>{open ? "arrow_drop_up" : "arrow_drop_down"}</Icon>
            </>
          }
          {...togglerProps}
        />
      </Box>

      {/* Dropdown Part */}
      <DropdownPopover
        id={`${id}-popover`}
        open={open}
        // anchorWidth={boxRef?.current?.offsetWidth}
        anchorEl={anchorEl}
        onClose={handleClose}
        PaperProps={{
          style: {},
          ...PaperProps,
          className: `${PaperProps.className || ""}`,
          sx: {
            minWidth: boxRef?.current?.offsetWidth || "auto",
          },
        }}
        {...props}
      >
        {children}
      </DropdownPopover>
    </>
  );
};
